const cardsData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20composition%20suggesting%20celebrity%20relationship%20drama%2C%20warm%20red%20and%20dark%20tones%2C%20soft%20romantic%20yet%20dramatic%20atmosphere%2C%20cinematic%20lighting%2C%20no%20text%2C%20no%20faces%2C%20editorial%20photography&width=600&height=400&seq=card-01-51cg&orientation=landscape',
    tag: '情感八卦',
    title: '2024娱乐圈分手离婚全记录',
    desc: '盘点了今年最令人震惊的十对明星分手事件，从官宣到实锤，完整时间线。',
    count: '12篇',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20image%20with%20warm%20crimson%20abstract%20shapes%20evoking%20variety%20show%20and%20reality%20TV%20drama%2C%20bold%20visual%20composition%2C%20cinematic%20style%2C%20no%20text%2C%20no%20faces%2C%20editorial%20photography&width=600&height=400&seq=card-02-51cg&orientation=landscape',
    tag: '综艺内幕',
    title: '热门综艺节目十大不为人知的幕后故事',
    desc: '从剪辑操控到剧本安排，揭秘综艺节目那些不为人知的制作内幕。',
    count: '8篇',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20editorial%20composition%20with%20amber%20highlights%20suggesting%20internet%20celebrity%20scandals%20and%20social%20media%20drama%2C%20textured%20background%2C%20cinematic%20feel%2C%20no%20text%2C%20no%20faces&width=600&height=400&seq=card-03-51cg&orientation=landscape',
    tag: '网红黑料',
    title: '2024年翻车网红大盘点',
    desc: '回顾今年因各种原因翻车的头部网红，从虚假人设到法律纠纷全收录。',
    count: '15篇',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20editorial%20image%20with%20red%20and%20black%20gradients%20evoking%20film%20industry%20behind%20the%20scenes%2C%20dramatic%20contrast%2C%20cinematic%20lighting%2C%20no%20text%2C%20no%20faces&width=600&height=400&seq=card-04-51cg&orientation=landscape',
    tag: '影视揭秘',
    title: '那些被雪藏的未上映电影',
    desc: '盘点因各种原因未能与观众见面的电影作品，背后的故事比电影更精彩。',
    count: '6篇',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20composition%20with%20deep%20red%20and%20dark%20tones%20suggesting%20music%20industry%20controversy%2C%20bold%20geometric%20elements%2C%20dramatic%20atmosphere%2C%20no%20text%2C%20no%20faces%2C%20editorial%20photography&width=600&height=400&seq=card-05-51cg&orientation=landscape',
    tag: '音乐圈',
    title: '音乐行业年度争议事件合集',
    desc: '从抄袭风波到假唱争议，2024年音乐圈最火爆的争议事件一一复盘。',
    count: '10篇',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门专题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">深度挖掘，持续追踪，吃瓜就该吃全套</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.slice(0, 3).map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 border border-background-200/60 rounded-lg overflow-hidden cursor-pointer hover:border-primary-200/60 transition-colors"
            >
              <div className="relative w-full" style={{ aspectRatio: '3/2' }}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                />
                <span className="absolute top-3 left-3 text-xs font-medium bg-accent-500 text-background-50 px-2 py-0.5 rounded whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3">{item.desc}</p>
                <span className="text-xs text-primary-500 font-medium">{item.count}</span>
              </div>
            </article>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {cardsData.slice(3, 5).map((item) => (
            <article
              key={item.id}
              className="group flex flex-col sm:flex-row bg-background-50 border border-background-200/60 rounded-lg overflow-hidden cursor-pointer hover:border-primary-200/60 transition-colors"
            >
              <div className="w-full sm:w-[200px] flex-shrink-0" style={{ aspectRatio: '3/2' }}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-4 flex flex-col justify-center">
                <span className="text-xs font-medium text-accent-500 w-fit mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-2">{item.desc}</p>
                <span className="text-xs text-primary-500 font-medium">{item.count}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}